import { get } from "@/utils/request";

const factoryPath = "/api/dots-collector-factory"

export function getOssSecurity(id) {
  return get(factoryPath + "/dict/oss-temp-security?id=" + id);
}
